export default __webpack_public_path__ + "static/Active Welcome Church Location Marker-7a1caea32a4bbceee0494979b3afbfa0.svg";